export default __webpack_public_path__ + "static/media/Icon-grid-black.221485a0.svg";